/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Trial_No_CardInputs */

const tr_pricing_trial_no_card = /** @type {(inputs: Pricing_Trial_No_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredi kartı gerekmez`)
};

const en_pricing_trial_no_card = /** @type {(inputs: Pricing_Trial_No_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credit card required`)
};

const de_pricing_trial_no_card = /** @type {(inputs: Pricing_Trial_No_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Kreditkarte erforderlich`)
};

const ru_pricing_trial_no_card = /** @type {(inputs: Pricing_Trial_No_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кредитная карта не требуется`)
};

/**
* | output |
* | --- |
* | "No credit card required" |
*
* @param {Pricing_Trial_No_CardInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_trial_no_card = /** @type {((inputs?: Pricing_Trial_No_CardInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trial_No_CardInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_trial_no_card(inputs)
	if (locale === "de") return de_pricing_trial_no_card(inputs)
	if (locale === "ru") return ru_pricing_trial_no_card(inputs)
	return tr_pricing_trial_no_card(inputs)
});